module.exports = __webpack_public_path__ + "static/dear-stranger-dearest-friend-69525dbe5a10205fb1dbefe7fd864cf8.jpg";